import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/**
 * Konten halaman publik yang dikelola admin dari dashboard.
 *
 * Dokumen yang belum pernah disunting admin datang TANPA `id` - dari situ
 * halaman tahu harus memakai teks artistik bawaannya sendiri, bukan teks
 * default server yang lebih polos.
 */
export const useSiteContent = () => {
  const { data } = useQuery({
    queryKey: ['public-site-content'],
    queryFn: () => api.get('/public/site-content'),
    staleTime: 60_000,
  });
  const konten = data?.data ?? null;
  return { konten, dikelola: Boolean(konten?.id) };
};

/** Harga paket terkini, sudah termasuk penimpa dari admin. */
export const usePublicPlans = () => {
  const { data } = useQuery({
    queryKey: ['public-plans'],
    queryFn: () => api.get('/public/plans'),
    staleTime: 60_000,
  });
  return data?.data ?? null;
};

/** Format tampilan harga: 0 -> "0", 25000 -> "25rb". */
export const hargaRingkas = (idr) => {
  if (!idr) return '0';
  if (idr >= 1_000_000) return `${(idr / 1_000_000).toLocaleString('id-ID')}jt`;
  if (idr >= 1000) return `${Math.round(idr / 1000)}rb`;
  return String(idr);
};

/** Masa berlaku, untuk kalimat yang berdiri sendiri: "Masa berlaku: 1 bulan". */
export const PERIODE = {
  1: '1 hari',
  7: '1 minggu',
  30: '1 bulan',
  90: '3 bulan',
  180: '6 bulan',
};

/**
 * Masa berlaku untuk kalimat berawalan "per".
 *
 * Terpisah dari `PERIODE` karena "per 1 bulan" terbaca janggal, sedangkan
 * "Masa berlaku: bulan" juga janggal. Dua bentuk yang sama artinya memang
 * lebih baik daripada satu bentuk yang salah di salah satu tempat.
 */
export const PERIODE_PER = {
  1: 'hari',
  7: 'minggu',
  30: 'bulan',
  90: '3 bulan',
  180: '6 bulan',
};
